/**
 * Application configuration
 */
import type { ProjectConfig } from 'framework/types/config'

import { ADMIN_PROJ_CFG_KEY } from 'framework/enums/cacheEnum'
import projectSetting from '@admin/settings/projectSetting'

import { useAppStore } from '@admin/store/modules/app'

import { getCommonStoragePrefix, getStorageShortName } from '@admin/utils/env'

import { Persistent } from 'framework/utils/cache/persistent'
import { deepMerge } from 'framework/utils'

// Initial project configuration
export function initAppConfigStore() {
  const appStore = useAppStore()
  let projCfg: ProjectConfig = Persistent.getLocal(ADMIN_PROJ_CFG_KEY) as ProjectConfig
  projCfg = deepMerge(projectSetting, projCfg || {})
  const darkMode = appStore.getDarkMode
  const {
    colorWeak,
    grayMode,
    themeColor,

    headerSetting: { bgColor: headerBgColor } = {},
    menuSetting: { bgColor } = {},
  } = projCfg
  appStore.setProjectConfig(projCfg)

  setTimeout(() => {
    clearObsoleteStorage()
  }, 16)
}

/**
 * As the version continues to iterate, there will be more and more cache keys stored in localStorage.
 * This method is used to delete useless keys
 */
export function clearObsoleteStorage() {
  const commonPrefix = getCommonStoragePrefix()
  const shortPrefix = getStorageShortName()

  ;[localStorage, sessionStorage].forEach((item: Storage) => {
    Object.keys(item).forEach((key) => {
      if (key && key.startsWith(commonPrefix) && !key.startsWith(shortPrefix)) {
        item.removeItem(key)
      }
    })
  })
}
